import { NullableMoment } from "../../utils/period_picker/PeriodPicker";
import gql from "graphql-tag";
import { getClient } from "../graphql";
import { RouteVariable, Route, RouteOutput } from "../../types/types";
import { ToDictionary } from "../routes";

type GitesRoutes = {
  gites: Route
}

type GraphqlResponse = {
  routes: RouteOutput<GitesRoutes>[]
}

type GraphqlVariables = {
  routes: RouteVariable<GitesRoutes>[]
}

const query = () => gql`
  query Submit($routes: [RouteInput!]!) {
    routes: routes(routes: $routes) {
      url
      path
      name
      identifier
    }
  }
`

export default async (startDate: NullableMoment, endDate: NullableMoment, maxPeople: number, booleans: string[] = []) => {
  const result = await getClient().query<GraphqlResponse, GraphqlVariables> ({
    query: query(),
    variables: {
      routes: [
        {
          identifier: "gites",
          name: "boolean_gites",
          args: {
            max_persons: maxPeople > 0 ? maxPeople : null,
            start_date: startDate ? startDate.format("DD-MM-YYYY") : '',
            end_date: endDate ? endDate.format("DD-MM-YYYY") : '',
            booleans: booleans,
          },
        }
      ]
    }
  });

  const routes = ToDictionary<GitesRoutes>(result.data.routes)
  window.location.href = routes.get('gites').path

}
